import auth from "@/services/ExerciseInitAuth"
import EventBus from "@/util/event-bus"
import { LIST_EVENTS } from "@/const/list-events.enum"
import axios from "axios"

const CHUNK_SIZE = 100 * 1024 * 1024 // 100MB chunks

const createMultipartUploadSession = (filename, filesize) => {
  return auth.post(
    `${process.env.VUE_APP_EXERCISE_API}admin/media-files/create_multipart_upload_session/`,
    { filename, filesize }
  )
}

const getPresignedPartUrl = (uploadId, key, partNumber) => {
  return auth.post(
    `${process.env.VUE_APP_EXERCISE_API}admin/media-files/get_presigned_part_url/`,
    { upload_id: uploadId, key, part_number: partNumber }
  )
}

const uploadPart = async (url, blob, partIndex, totalParts, totalSize) => {
  const response = await axios.put(url, blob, {
    headers: {
      'Content-Type': 'application/octet-stream'
    },
    onUploadProgress: (progressEvent) => {
      const partProgress = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      )
      
      // Calculate overall progress considering completed parts and current part progress
      const partSize = blob.size
      const completedPartsSize = partIndex * CHUNK_SIZE
      const currentPartUploaded = (partProgress / 100) * partSize
      
      const overallProgress = Math.round(
        ((completedPartsSize + currentPartUploaded) * 100) / totalSize
      )
      
      EventBus.$emit(LIST_EVENTS.FILE_UPLOAD_PROGRESS, overallProgress)
    }
  })

  return response.headers.etag || response.headers['Etag']
}

const completeMultipartUpload = (uploadId, key, parts) => {
  return auth.post(
    `${process.env.VUE_APP_EXERCISE_API}admin/media-files/complete_multipart_upload/`,
    { upload_id: uploadId, key, parts }
  )
}

const uploadLargeFile = async (file) => {
  // Initialize multipart upload
  const { multipart_data, file: fileInfo } = await createMultipartUploadSession(file.name, file.size)
  const { upload_id: uploadId, key } = multipart_data
  
  // Calculate total parts
  const totalParts = Math.ceil(file.size / CHUNK_SIZE)
  const parts = []

  // Upload each part
  for (let i = 0; i < totalParts; i++) {
    const partNumber = i + 1
    const start = i * CHUNK_SIZE
    const end = Math.min(file.size, start + CHUNK_SIZE)
    const blob = file.slice(start, end)

    const presignedData = await getPresignedPartUrl(uploadId, key, partNumber)
    const etag = await uploadPart(presignedData.url, blob, i, totalParts, file.size)

    parts.push({
      ETag: etag,
      PartNumber: partNumber
    })
  }
  
  // Complete the multipart upload
  const response = await completeMultipartUpload(uploadId, key, parts)

  return {
    file: fileInfo,
    response
  }
}

const isLargeFile = (file) => {
  return file.size > 4 * 1024 * 1024 * 1024 // 4GB
}

export default {
  uploadLargeFile,
  isLargeFile,
  CHUNK_SIZE
}